<template>
    <v-container>
        <v-row align="center">
            <v-col cols="6" md="4" lg="3" class="mx-auto" v-for="(item, index) in data.list" :key="index" >
                <v-img
                    :lazy-src="item.image.sizes.thumbnail"
                    lazy
                    :src="item.image.sizes.full"
                    cover
                    :aspect-ratio="1/1"
                    gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,0),  rgba(0,0,0,1)"
                    :alt="item.image.title+' - '+item.image.description"
                    class="mx-auto"
                >
                    <v-container class="fill-height">
                     <v-row no-gutters class="fill-height" align="end">
                        <v-col cols="12" >
                            <p class="m-0 line-height-1">
                                <strong>{{ item.name }}</strong><br>
                                <small>{{ item.role }}</small>
                            </p>
                        </v-col>
                     </v-row>
                    </v-container>
                </v-img>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'PeopleListComponent',
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
       
    }),
    mounted(){
        
    }
}
</script>

<style>

.line-height-1{
    line-height: 1
}

</style>